import React from "react";
import "./styles.scss";
import Header from "../../components/header";
import CardImage from "../../assets/images/man-putting-key-card-switch-hotel-room.jpg";
import FingerPrintImage from "../../assets/images/close-up-fingerprint-reader (1).jpg";
import FaceIdImage from "../../assets/images/biometrics-concept-identity-person-use.jpg";
import FlapBarrierImage from "../../assets/images/ticket-barriers-subway-entrance.jpg";
import TripodImage from "../../assets/images/tripod.jpg";
import BiometricBanner from "../../assets/images/biometric_banner.jpg";
import Footer from "../../components/footer";

const BiometricIntegration = () => {
  const biometricSystems = [
    {
      title: "Privilege Card",
      description:
        "A secure access system that grants gym members entry using a registered card, ensuring seamless check-ins and enhanced security",
      image: CardImage,
    },
    {
      title: "Fingerprint Reader",
      description:
        "A biometric access control device that scans and verifies fingerprints, ensuring secure and convenient entry for authorized users",
      image: FingerPrintImage,
    },
    {
      title: "Face Reader",
      description:
        "Advanced facial recognition system that authenticates users by analyzing facial features, providing a touchless and secure access solution",
      image: FaceIdImage,
    },
    {
      title: "Flap Barrier",
      description:
        "Automated entry system with retractable flaps that regulate pedestrian access, commonly used in high-security areas like offices, metro stations, and commercial buildings",
      image: FlapBarrierImage,
    },
    {
      title: "Tripod Turnstile Solution",
      description:
        "Rotating gate mechanism designed to control and restrict pedestrian movement, enhancing security by allowing only authorized individuals to pass through",
      image: TripodImage,
    },
  ];

  return (
    <div className="features-page">
      <Header />

      {/* Banner Section */}
      <section
        className="features-banner"
        style={{ backgroundImage: `url(${BiometricBanner})` }}
      >
        <div className="container">
          <h1>BIOMETRIC INTEGRATION</h1>
        </div>
      </section>

      {/* Content Section */}

      {/* Biometric Systems */}
      {biometricSystems.map((system, index) => (
        <section className="feature-section" key={index}>
          <div className="container">
            <div className="row align-items-center">
              <div
                className={`col-md-6 ${index % 2 === 1 ? "order-md-2" : ""}`}
              >
                <img
                  src={system.image}
                  alt={system.title}
                  className="feature-image"
                />
              </div>
              <div
                className={`col-md-6 ${index % 2 === 1 ? "order-md-1" : ""}`}
              >
                <div className="feature-content">
                  <h2>{system.title}</h2>
                  <p>{system.description}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
      <Footer />
    </div>
  );
};

export default BiometricIntegration;
